import { createContext, useState } from "react";
import { connect } from "react-redux";

export const AiContext = createContext(null);

const AiContextProvider = ({ children }) => {
  const initAiCaptionState = {
    default: "",
    facebook: "",
    linkedin: "",
    instagram: "",
    twitter: "",
    youtube: "",
    tiktok: "",
    meta_threads: "",
    pinterest: "",
  };

  const [generatedBrandInfo, setGeneratedBrandInfo] = useState(null);
  const [postIdeaList, setPostIdeaList] = useState([]);
  const [selectedAiTool, setSelectedAiTool] = useState(null);
  const [fromIdeas, setFromIdeas] = useState(false); //helps to trigger generating caption if user is coming from post idea modal
  const [resultModalContent, setResultModalContent] = useState(null);
  const [contentByPlatform, setContentByPlatform] =
    useState(initAiCaptionState);

  return (
    <AiContext.Provider
      value={{
        generatedBrandInfo,
        setGeneratedBrandInfo,
        postIdeaList,
        setPostIdeaList,
        selectedAiTool,
        setSelectedAiTool,
        resultModalContent,
        setResultModalContent,
        contentByPlatform,
        setContentByPlatform,
        initAiCaptionState,
        fromIdeas,
        setFromIdeas,
      }}
    >
      {children}
    </AiContext.Provider>
  );
};

const mapStateToProps = (state) => {
  return {
    active_account: state.active_account,
  };
};

export default connect(mapStateToProps)(AiContextProvider);
